// extracted by mini-css-extract-plugin
module.exports = {"logo-banner-img":"AssetBanner_logo-banner-img__Urm5Z","desktop":"AssetBanner_desktop__lVzRE","mobile":"AssetBanner_mobile__q4cVC"};